export default "__VITE_ASSET___mtkgqer__"